import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { logoutUser } from 'app/ducks/authentication/actions';
import FooterBar from './components/FooterBar';

const authentication = (state) => state.authentication;

export const selector = createStructuredSelector({ authentication });

export const actionCreators = {
  logoutUser,
};

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class Footer extends React.Component {
  static propTypes = {
    actions: PropTypes.object,
  };

  static defaultProps = {
    actions: undefined,
  };

  render() {
    return (<FooterBar {...this.props} logoutUser={this.props.actions.logoutUser} />);
  }
}
